// extracted by mini-css-extract-plugin
export default {"card":"AnalyticsCard_card__W6DLP"};